// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.permisos-page[data-v-40de47ec] {
    --ink: #1b2740;
    --soft: #5c6b86;
    --line: #d5deea;
    --field: #8b97ab;
    --sheet: #f3f6fa;
    --senal: #ff7900;
    --peligro: #9b1c3c;
    --mono: ui-monospace, "SFMono-Regular", "Cascadia Mono", Menlo, Consolas, monospace;
    margin-top: -0.75rem;
    padding-top: 1.15rem;
    background: #fff;
    color: var(--ink);
}
.permisos-formulario[data-v-40de47ec] {
    max-width: 72rem;
    margin-left: auto;
    margin-right: auto;
}
.permisos-cabecera[data-v-40de47ec] {
    margin-bottom: 1.15rem;
}
.permisos-cabecera-fila[data-v-40de47ec] {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem 1.25rem;
    margin-top: 1rem;
}
.permisos-formulario #seccionCabecera .permisos-title-row[data-v-40de47ec] {
    margin-top: 0;
}

/* Las dos etiquetas comparten celda: el botón mide siempre lo que la más larga. */
.permisos-alta-toggle-textos[data-v-40de47ec] {
    display: inline-grid;
}
.permisos-alta-toggle-textos > span[data-v-40de47ec] {
    grid-area: 1 / 1;
    text-align: center;
}
.permisos-alta-toggle-textos > .es-oculto[data-v-40de47ec] {
    visibility: hidden;
}
.permisos-formulario .permisos-alta-toggle[data-v-40de47ec] {
    flex: 0 0 auto;
    margin-top: -0.15rem;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 0.9rem;
    border: 1px solid var(--ink);
    border-radius: 4px;
    background: var(--ink);
    color: #fff;
    font-weight: 600;
    white-space: nowrap;
    transition: background-color 0.16s ease, color 0.16s ease;
}
.permisos-formulario .permisos-alta-toggle[data-v-40de47ec]:hover {
    background: #121a2c;
    border-color: #121a2c;
    color: #fff;
}
.permisos-formulario .permisos-alta-toggle.abierta[data-v-40de47ec] {
    background: #fff;
    color: var(--ink);
}
.permisos-formulario .permisos-alta-toggle.abierta[data-v-40de47ec]:hover {
    background: var(--sheet);
    border-color: var(--ink);
    color: var(--ink);
}
.permisos-alta-toggle-icono[data-v-40de47ec] {
    font-size: 0.8rem;
    transition: transform 0.2s ease;
}
.permisos-alta-toggle.abierta .permisos-alta-toggle-icono[data-v-40de47ec] {
    transform: rotate(45deg);
}

/* Cerrado, el panel no ocupa sitio ni entra en el orden de tabulación. */
.permisos-alta-panel[data-v-40de47ec] {
    display: grid;
    grid-template-rows: 0fr;
    visibility: hidden;
    transition: grid-template-rows 0.25s ease, visibility 0s linear 0.25s;
}
.permisos-alta-panel.abierta[data-v-40de47ec] {
    grid-template-rows: 1fr;
    visibility: visible;
    transition: grid-template-rows 0.25s ease, visibility 0s;
}
.permisos-alta-panel-interior[data-v-40de47ec] {
    min-height: 0;
    overflow: hidden;
}
.permisos-alta-panel .permisos-sheet[data-v-40de47ec] {
    margin-bottom: 1.6rem;
}
.permisos-formulario #seccionCabecera p[data-v-40de47ec] {
    text-align: left;
    padding-left: 0;
    margin-bottom: 0;
}
.permisos-title[data-v-40de47ec] {
    display: block;
    font-size: 2rem;
    font-weight: 600;
    letter-spacing: -0.03em;
    line-height: 1.05;
    color: var(--ink);
}
.permisos-title[data-v-40de47ec]::after {
    content: "";
    display: block;
    width: 2.25rem;
    height: 3px;
    margin-top: 0.55rem;
    background: var(--senal);
}
.permisos-formulario #seccionCabecera .permisos-lead[data-v-40de47ec] {
    max-width: 46rem;
    margin-top: 0.55rem;
    color: var(--soft);
    font-size: 0.95rem;
}
.permisos-sheet[data-v-40de47ec] {
    background: var(--sheet);
    border: 1px solid var(--line);
    border-radius: 6px;
    padding: 1.1rem 1.2rem 1.05rem;
}
.permisos-bloque-titulo[data-v-40de47ec] {
    margin: 0 0 0.7rem;
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 1.2;
    color: var(--ink);
}
.permisos-label[data-v-40de47ec] {
    display: block;
    margin-bottom: 0.3rem;
    color: var(--ink);
    font-size: 0.82rem;
    font-weight: 600;
}
.permisos-formulario .form-control[data-v-40de47ec] {
    border-color: var(--field);
    border-radius: 4px;
    color: var(--ink);
}
.permisos-formulario .form-control[data-v-40de47ec]:focus {
    border-color: var(--ink);
    box-shadow: 0 0 0 3px rgba(27, 39, 64, 0.14);
}
.permisos-nota[data-v-40de47ec] {
    margin: 0.75rem 0 0;
    color: var(--soft);
    font-size: 0.82rem;
}
.permisos-error[data-v-40de47ec] {
    margin: 0.75rem 0 0;
    padding: 0.5rem 0.75rem;
    border-left: 3px solid var(--peligro);
    background: #fbf1f4;
    color: var(--peligro);
    font-size: 0.88rem;
}
.permisos-aviso[data-v-40de47ec] {
    margin: 0.75rem 0 0;
    padding: 0.45rem 0.75rem;
    border-left: 3px solid var(--senal);
    background: #fff6ee;
    color: var(--ink);
    font-size: 0.85rem;
}
.permisos-vacio[data-v-40de47ec] {
    margin: 0;
    color: var(--soft);
    font-size: 0.9rem;
}

/* Alta */
.permisos-alta[data-v-40de47ec] {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.75rem 1rem;
    align-items: end;
}
.permisos-alta-indicadores[data-v-40de47ec] {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.6rem;
}

/* Interruptor: la misma pieza en el listado, el alta y la ficha */
.permisos-switch[data-v-40de47ec] {
    position: relative;
    flex: 0 0 auto;
    display: inline-block;
    width: 2.15rem;
    height: 1.2rem;
    border-radius: 999px;
    background: #c9d2df;
    transition: background-color 0.16s ease;
}
.permisos-switch[data-v-40de47ec]::after {
    content: "";
    position: absolute;
    top: 0.175rem;
    left: 0.175rem;
    width: 0.85rem;
    height: 0.85rem;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 2px rgba(27, 39, 64, 0.25);
    transition: transform 0.18s ease, background-color 0.16s ease;
}
[aria-checked="true"] > .permisos-switch[data-v-40de47ec] {
    background: var(--senal);
}
[aria-checked="true"] > .permisos-switch[data-v-40de47ec]::after {
    transform: translateX(0.95rem);
}
.permisos-switch-boton[data-v-40de47ec] {
    display: inline-flex;
    padding: 0.35rem;
    border: 0;
    border-radius: 999px;
    background: transparent;
    cursor: pointer;
}
.permisos-switch-boton[data-v-40de47ec]:focus-visible,
.permisos-toma[data-v-40de47ec]:focus-visible,
.permisos-formulario .btn[data-v-40de47ec]:focus-visible {
    outline: 2px solid var(--ink);
    outline-offset: 2px;
}

/* Toma: un interruptor con su nombre, para el alta y la ficha */
.permisos-toma[data-v-40de47ec] {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    width: 100%;
    min-height: 2.75rem;
    padding: 0.55rem 0.75rem;
    border: 1px solid var(--line);
    border-radius: 4px;
    background: #fff;
    color: var(--soft);
    text-align: left;
    cursor: pointer;
    transition: border-color 0.16s ease, box-shadow 0.16s ease, color 0.16s ease;
}
.permisos-toma[data-v-40de47ec]:hover {
    border-color: var(--field);
    color: var(--ink);
}
.permisos-toma[aria-checked="true"][data-v-40de47ec] {
    border-color: var(--ink);
    box-shadow: inset 3px 0 0 var(--senal);
    color: var(--ink);
}
.permisos-toma-texto[data-v-40de47ec] {
    display: flex;
    flex-direction: column;
    min-width: 0;
}
.permisos-toma-nombre[data-v-40de47ec] {
    font-weight: 600;
    font-size: 0.9rem;
    line-height: 1.2;
}
.permisos-toma-ayuda[data-v-40de47ec] {
    margin-top: 0.15rem;
    font-size: 0.78rem;
    line-height: 1.3;
    color: var(--soft);
}
.permisos-codigo[data-v-40de47ec] {
    font-family: var(--mono);
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0.01em;
    color: var(--ink);
}

/* Listado */
.permisos-roster[data-v-40de47ec] {
    margin-top: 0.4rem;
}
.permisos-roster-head[data-v-40de47ec] {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 0.75rem 1.25rem;
    margin-bottom: 0.6rem;
}
.permisos-cuenta[data-v-40de47ec] {
    margin: 0.2rem 0 0;
    color: var(--soft);
    font-size: 0.8rem;
}
.permisos-buscar[data-v-40de47ec] {
    position: relative;
    width: min(100%, 20rem);
}
.permisos-buscar-icono[data-v-40de47ec] {
    position: absolute;
    top: 50%;
    left: 0.7rem;
    transform: translateY(-50%);
    color: var(--field);
    font-size: 0.8rem;
    pointer-events: none;
}
.permisos-buscar .form-control[data-v-40de47ec] {
    padding-left: 2rem;
}
.permisos-tabla-wrap[data-v-40de47ec] {
    overflow-x: auto;
    border-top: 2px solid var(--ink);
}
.permisos-tabla[data-v-40de47ec] {
    width: 100%;
    border-collapse: collapse;
}
.permisos-tabla thead th[data-v-40de47ec] {
    padding: 0.55rem 0.6rem;
    border-bottom: 1px solid var(--line);
    color: var(--soft);
    font-size: 0.75rem;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
}
.permisos-tabla thead th.permisos-th-indicador[data-v-40de47ec] {
    width: 8.5rem;
    text-align: center;
}
.permisos-tabla tbody tr[data-v-40de47ec] {
    border-bottom: 1px solid var(--line);
    transition: background-color 0.12s ease;
}
.permisos-tabla tbody tr[data-v-40de47ec]:hover {
    background: #f8fafc;
}
.permisos-tabla tbody tr.es-ficha[data-v-40de47ec] {
    background: var(--sheet);
    box-shadow: inset 3px 0 0 var(--senal);
}
.permisos-tabla tbody th[data-v-40de47ec],
.permisos-tabla tbody td[data-v-40de47ec] {
    padding: 0.4rem 0.6rem;
    vertical-align: middle;
}
.permisos-email[data-v-40de47ec] {
    font-weight: 600;
    color: var(--ink);
    word-break: break-all;
}
.permisos-email-dominio[data-v-40de47ec] {
    font-weight: 400;
    color: var(--soft);
}
.permisos-td-indicador[data-v-40de47ec] {
    text-align: center;
}
.permisos-acciones[data-v-40de47ec] {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.35rem;
    white-space: nowrap;
}
.permisos-nadie[data-v-40de47ec] {
    padding: 1rem 0.6rem;
    color: var(--soft);
    font-size: 0.9rem;
}

/* Botones */
.permisos-formulario .permisos-commit[data-v-40de47ec] {
    background: var(--ink);
    border-color: var(--ink);
    border-radius: 4px;
    color: #fff;
    font-weight: 600;
}
.permisos-formulario .permisos-commit[data-v-40de47ec]:hover:not(:disabled) {
    background: #121a2c;
    border-color: #121a2c;
    color: #fff;
}
.permisos-formulario .permisos-commit[data-v-40de47ec]:disabled {
    background: #c5cedb;
    border-color: #c5cedb;
    color: #fff;
    opacity: 1;
}
.permisos-formulario .permisos-abrir[data-v-40de47ec] {
    padding: 0.25rem 0.7rem;
    border: 1px solid #c5cedb;
    border-radius: 4px;
    background: transparent;
    color: var(--ink);
    font-size: 0.85rem;
    font-weight: 600;
}
.permisos-formulario .permisos-abrir[data-v-40de47ec]:hover {
    background: var(--ink);
    border-color: var(--ink);
    color: #fff;
}
.permisos-formulario .permisos-borrar[data-v-40de47ec] {
    width: 2rem;
    height: 2rem;
    padding: 0;
    border: 1px solid transparent;
    border-radius: 4px;
    background: transparent;
    color: var(--peligro);
    font-size: 0.85rem;
}
.permisos-formulario .permisos-borrar[data-v-40de47ec]:hover {
    background: var(--peligro);
    border-color: var(--peligro);
    color: #fff;
}

/* Ficha */
.permisos-modal-eyebrow[data-v-40de47ec] {
    display: block;
    color: var(--soft);
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}
.permisos-modal-email[data-v-40de47ec] {
    display: block;
    margin-top: 0.2rem;
    color: var(--ink);
    font-size: 1.35rem;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 1.2;
    word-break: break-all;
}
.permisos-bloque + .permisos-bloque[data-v-40de47ec] {
    margin-top: 1.5rem;
    padding-top: 1.25rem;
    border-top: 1px solid var(--line);
}
.permisos-bloque-cabeza[data-v-40de47ec] {
    margin-bottom: 0.75rem;
}
.permisos-bloque-nombre[data-v-40de47ec] {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: var(--ink);
}
.permisos-bloque-ayuda[data-v-40de47ec] {
    margin: 0.15rem 0 0;
    color: var(--soft);
    font-size: 0.85rem;
}
.permisos-dominios[data-v-40de47ec] {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(8.5rem, 1fr));
    gap: 0.6rem;
}
.permisos-origenes[data-v-40de47ec] {
    margin: 0;
    padding: 0;
    list-style: none;
}
.permisos-origen[data-v-40de47ec] {
    display: grid;
    grid-template-columns: minmax(5rem, 9rem) minmax(0, 1fr) 2.75rem minmax(0, 1fr);
    align-items: center;
    padding: 0.35rem 0;
}
.permisos-origen + .permisos-origen[data-v-40de47ec] {
    border-top: 1px dashed var(--line);
}

/* Conector: une Enviar y Listas cuando las listas arrastran el envío */
.permisos-conector[data-v-40de47ec] {
    height: 2px;
    background-image: linear-gradient(90deg, var(--line) 50%, transparent 50%);
    background-size: 6px 2px;
    transition: background 0.16s ease;
}
.con-envio .permisos-conector[data-v-40de47ec] {
    background: var(--line);
}
.con-listas .permisos-conector[data-v-40de47ec] {
    height: 3px;
    background: var(--senal);
}
.arrastre-previsto .permisos-conector[data-v-40de47ec] {
    height: 3px;
    background-image: linear-gradient(90deg, var(--senal) 50%, transparent 50%);
    background-size: 8px 3px;
}
.permisos-toma.se-arrastra[data-v-40de47ec] {
    border-style: dashed;
    border-color: var(--senal);
    background: #fff6ee;
    color: var(--ink);
}
.permisos-estado[data-v-40de47ec] {
    flex: 1 1 auto;
    margin: 0;
    color: var(--soft);
    font-size: 0.85rem;
}
.permisos-estado.es-error[data-v-40de47ec] {
    color: var(--peligro);
    font-weight: 600;
}
@media (max-width: 760px) {
.permisos-page[data-v-40de47ec] {
        padding-top: 0.85rem;
}
.permisos-sheet[data-v-40de47ec] {
        padding: 0.95rem 0.85rem 0.9rem;
}
.permisos-title[data-v-40de47ec] {
        font-size: 1.7rem;
}
.permisos-alta[data-v-40de47ec],
    .permisos-alta-indicadores[data-v-40de47ec] {
        grid-template-columns: 1fr;
}
.permisos-alta-accion[data-v-40de47ec] {
        order: 3;
}
.permisos-alta-accion .btn[data-v-40de47ec] {
        width: 100%;
}
.permisos-roster-head[data-v-40de47ec] {
        flex-direction: column;
        align-items: stretch;
}
.permisos-buscar[data-v-40de47ec] {
        width: 100%;
}
.permisos-tabla thead[data-v-40de47ec] {
        position: absolute;
        width: 1px;
        height: 1px;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
}
.permisos-tabla tbody tr[data-v-40de47ec] {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        padding: 0.75rem 0.25rem;
}
.permisos-tabla tbody th[data-v-40de47ec],
    .permisos-tabla tbody td[data-v-40de47ec] {
        display: block;
        padding: 0.2rem 0.35rem;
}
.permisos-tabla tbody th.permisos-email[data-v-40de47ec],
    .permisos-tabla tbody td.permisos-td-acciones[data-v-40de47ec],
    .permisos-tabla tbody td.permisos-nadie[data-v-40de47ec] {
        grid-column: 1 / -1;
}
.permisos-td-indicador[data-v-40de47ec] {
        text-align: left;
}
.permisos-td-indicador[data-v-40de47ec]::before {
        content: attr(data-label);
        display: block;
        color: var(--soft);
        font-size: 0.72rem;
        font-weight: 600;
}
.permisos-switch-boton[data-v-40de47ec] {
        padding-left: 0;
}
.permisos-acciones[data-v-40de47ec] {
        justify-content: space-between;
        margin-top: 0.35rem;
}
.permisos-origen[data-v-40de47ec] {
        grid-template-columns: 1fr 1fr;
        gap: 0.45rem 0.6rem;
        padding: 0.6rem 0;
}
.permisos-origen > .permisos-codigo[data-v-40de47ec] {
        grid-column: 1 / -1;
}
.permisos-conector[data-v-40de47ec] {
        display: none;
}
}
@media (prefers-reduced-motion: reduce) {
.permisos-alta-panel[data-v-40de47ec],
    .permisos-alta-panel.abierta[data-v-40de47ec],
    .permisos-alta-toggle[data-v-40de47ec],
    .permisos-alta-toggle-icono[data-v-40de47ec],
    .permisos-switch[data-v-40de47ec],
    .permisos-switch[data-v-40de47ec]::after,
    .permisos-toma[data-v-40de47ec],
    .permisos-conector[data-v-40de47ec],
    .permisos-tabla tbody tr[data-v-40de47ec] {
        transition: none;
}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/permisosUser.vue"],"names":[],"mappings":";AAspBA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mFAAmF;IACnF,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;AACrB;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AAEA;IACI,sBAAsB;AAC1B;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,oBAAoB;IACpB,gBAAgB;AACpB;AAEA;IACI,aAAa;AACjB;;AAEA,kFAAkF;AAClF;IACI,oBAAoB;AACxB;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI,kBAAkB;AACtB;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,yDAAyD;AAC7D;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AAEA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,iBAAiB;AACrB;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;AAEA;IACI,wBAAwB;AAC5B;;AAEA,yEAAyE;AACzE;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,qEAAqE;AACzE;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,wDAAwD;AAC5D;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;AACrB;AAEA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,wBAAwB;AAC5B;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,kBAAkB;IAClB,8BAA8B;AAClC;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;AACrB;AAEA;IACI,wBAAwB;IACxB,4CAA4C;AAChD;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,mCAAmC;IACnC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,SAAS;AAET;IACI,aAAa;IACb,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;AACpB;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gDAAgD;IAChD,WAAW;AACf;;AAEA,kEAAkE;AAElE;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uCAAuC;AAC3C;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;IAC5C,6DAA6D;AACjE;AAEA;IACI,wBAAwB;AAC5B;AAEA;IACI,8BAA8B;AAClC;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;AACnB;AAEA;;;IAGI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA,gEAAgE;AAEhE;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4EAA4E;AAChF;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;AAEA;IACI,wBAAwB;IACxB,sCAAsC;IACtC,iBAAiB;AACrB;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA,YAAY;AAEZ;IACI,kBAAkB;AACtB;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,oBAAoB;IACpB,qBAAqB;AACzB;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;AAEA;IACI,kBAAkB;AACtB;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;AAEA;IACI,oCAAoC;IACpC,uCAAuC;AAC3C;AAEA;IACI,mBAAmB;AACvB;AAEA;IACI,wBAAwB;IACxB,sCAAsC;AAC1C;AAEA;;IAEI,sBAAsB;IACtB,sBAAsB;AAC1B;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI,kBAAkB;AACtB;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,YAAY;AAEZ;IACI,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,UAAU;AACd;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,WAAW;AACf;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;AACtB;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;AACf;;AAEA,UAAU;AAEV;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;AACzB;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iCAAiC;AACrC;AAEA;IACI,sBAAsB;AAC1B;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AAEA;IACI,aAAa;IACb,6DAA6D;IAC7D,WAAW;AACf;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AAEA;IACI,aAAa;IACb,+EAA+E;IAC/E,mBAAmB;IACnB,kBAAkB;AACtB;AAEA;IACI,kCAAkC;AACtC;;AAEA,uEAAuE;AAEvE;IACI,WAAW;IACX,0EAA0E;IAC1E,wBAAwB;IACxB,iCAAiC;AACrC;AAEA;IACI,uBAAuB;AAC3B;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;AAEA;IACI,WAAW;IACX,2EAA2E;IAC3E,wBAAwB;AAC5B;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;AACrB;AAEA;IACI,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AAEA;AACI;QACI,oBAAoB;AACxB;AAEA;QACI,+BAA+B;AACnC;AAEA;QACI,iBAAiB;AACrB;AAEA;;QAEI,0BAA0B;AAC9B;AAEA;QACI,QAAQ;AACZ;AAEA;QACI,WAAW;AACf;AAEA;QACI,sBAAsB;QACtB,oBAAoB;AACxB;AAEA;QACI,WAAW;AACf;AAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,sBAAsB;QACtB,mBAAmB;AACvB;AAEA;QACI,aAAa;QACb,gDAAgD;QAChD,wBAAwB;AAC5B;AAEA;;QAEI,cAAc;QACd,uBAAuB;AAC3B;AAEA;;;QAGI,mBAAmB;AACvB;AAEA;QACI,gBAAgB;AACpB;AAEA;QACI,yBAAyB;QACzB,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;AACpB;AAEA;QACI,eAAe;AACnB;AAEA;QACI,8BAA8B;QAC9B,mBAAmB;AACvB;AAEA;QACI,8BAA8B;QAC9B,mBAAmB;QACnB,iBAAiB;AACrB;AAEA;QACI,mBAAmB;AACvB;AAEA;QACI,aAAa;AACjB;AACJ;AAEA;AACI;;;;;;;;;QASI,gBAAgB;AACpB;AACJ","sourcesContent":["\n.permisos-page {\n    --ink: #1b2740;\n    --soft: #5c6b86;\n    --line: #d5deea;\n    --field: #8b97ab;\n    --sheet: #f3f6fa;\n    --senal: #ff7900;\n    --peligro: #9b1c3c;\n    --mono: ui-monospace, \"SFMono-Regular\", \"Cascadia Mono\", Menlo, Consolas, monospace;\n    margin-top: -0.75rem;\n    padding-top: 1.15rem;\n    background: #fff;\n    color: var(--ink);\n}\n\n.permisos-formulario {\n    max-width: 72rem;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.permisos-cabecera {\n    margin-bottom: 1.15rem;\n}\n\n.permisos-cabecera-fila {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 0.75rem 1.25rem;\n    margin-top: 1rem;\n}\n\n.permisos-formulario #seccionCabecera .permisos-title-row {\n    margin-top: 0;\n}\n\n/* Las dos etiquetas comparten celda: el botón mide siempre lo que la más larga. */\n.permisos-alta-toggle-textos {\n    display: inline-grid;\n}\n\n.permisos-alta-toggle-textos > span {\n    grid-area: 1 / 1;\n    text-align: center;\n}\n\n.permisos-alta-toggle-textos > .es-oculto {\n    visibility: hidden;\n}\n\n.permisos-formulario .permisos-alta-toggle {\n    flex: 0 0 auto;\n    margin-top: -0.15rem;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.4rem 0.9rem;\n    border: 1px solid var(--ink);\n    border-radius: 4px;\n    background: var(--ink);\n    color: #fff;\n    font-weight: 600;\n    white-space: nowrap;\n    transition: background-color 0.16s ease, color 0.16s ease;\n}\n\n.permisos-formulario .permisos-alta-toggle:hover {\n    background: #121a2c;\n    border-color: #121a2c;\n    color: #fff;\n}\n\n.permisos-formulario .permisos-alta-toggle.abierta {\n    background: #fff;\n    color: var(--ink);\n}\n\n.permisos-formulario .permisos-alta-toggle.abierta:hover {\n    background: var(--sheet);\n    border-color: var(--ink);\n    color: var(--ink);\n}\n\n.permisos-alta-toggle-icono {\n    font-size: 0.8rem;\n    transition: transform 0.2s ease;\n}\n\n.permisos-alta-toggle.abierta .permisos-alta-toggle-icono {\n    transform: rotate(45deg);\n}\n\n/* Cerrado, el panel no ocupa sitio ni entra en el orden de tabulación. */\n.permisos-alta-panel {\n    display: grid;\n    grid-template-rows: 0fr;\n    visibility: hidden;\n    transition: grid-template-rows 0.25s ease, visibility 0s linear 0.25s;\n}\n\n.permisos-alta-panel.abierta {\n    grid-template-rows: 1fr;\n    visibility: visible;\n    transition: grid-template-rows 0.25s ease, visibility 0s;\n}\n\n.permisos-alta-panel-interior {\n    min-height: 0;\n    overflow: hidden;\n}\n\n.permisos-alta-panel .permisos-sheet {\n    margin-bottom: 1.6rem;\n}\n\n.permisos-formulario #seccionCabecera p {\n    text-align: left;\n    padding-left: 0;\n    margin-bottom: 0;\n}\n\n.permisos-title {\n    display: block;\n    font-size: 2rem;\n    font-weight: 600;\n    letter-spacing: -0.03em;\n    line-height: 1.05;\n    color: var(--ink);\n}\n\n.permisos-title::after {\n    content: \"\";\n    display: block;\n    width: 2.25rem;\n    height: 3px;\n    margin-top: 0.55rem;\n    background: var(--senal);\n}\n\n.permisos-formulario #seccionCabecera .permisos-lead {\n    max-width: 46rem;\n    margin-top: 0.55rem;\n    color: var(--soft);\n    font-size: 0.95rem;\n}\n\n.permisos-sheet {\n    background: var(--sheet);\n    border: 1px solid var(--line);\n    border-radius: 6px;\n    padding: 1.1rem 1.2rem 1.05rem;\n}\n\n.permisos-bloque-titulo {\n    margin: 0 0 0.7rem;\n    font-size: 0.95rem;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n    color: var(--ink);\n}\n\n.permisos-label {\n    display: block;\n    margin-bottom: 0.3rem;\n    color: var(--ink);\n    font-size: 0.82rem;\n    font-weight: 600;\n}\n\n.permisos-formulario .form-control {\n    border-color: var(--field);\n    border-radius: 4px;\n    color: var(--ink);\n}\n\n.permisos-formulario .form-control:focus {\n    border-color: var(--ink);\n    box-shadow: 0 0 0 3px rgba(27, 39, 64, 0.14);\n}\n\n.permisos-nota {\n    margin: 0.75rem 0 0;\n    color: var(--soft);\n    font-size: 0.82rem;\n}\n\n.permisos-error {\n    margin: 0.75rem 0 0;\n    padding: 0.5rem 0.75rem;\n    border-left: 3px solid var(--peligro);\n    background: #fbf1f4;\n    color: var(--peligro);\n    font-size: 0.88rem;\n}\n\n.permisos-aviso {\n    margin: 0.75rem 0 0;\n    padding: 0.45rem 0.75rem;\n    border-left: 3px solid var(--senal);\n    background: #fff6ee;\n    color: var(--ink);\n    font-size: 0.85rem;\n}\n\n.permisos-vacio {\n    margin: 0;\n    color: var(--soft);\n    font-size: 0.9rem;\n}\n\n/* Alta */\n\n.permisos-alta {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 0.75rem 1rem;\n    align-items: end;\n}\n\n.permisos-alta-indicadores {\n    grid-column: 1 / -1;\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 0.6rem;\n}\n\n/* Interruptor: la misma pieza en el listado, el alta y la ficha */\n\n.permisos-switch {\n    position: relative;\n    flex: 0 0 auto;\n    display: inline-block;\n    width: 2.15rem;\n    height: 1.2rem;\n    border-radius: 999px;\n    background: #c9d2df;\n    transition: background-color 0.16s ease;\n}\n\n.permisos-switch::after {\n    content: \"\";\n    position: absolute;\n    top: 0.175rem;\n    left: 0.175rem;\n    width: 0.85rem;\n    height: 0.85rem;\n    border-radius: 50%;\n    background: #fff;\n    box-shadow: 0 1px 2px rgba(27, 39, 64, 0.25);\n    transition: transform 0.18s ease, background-color 0.16s ease;\n}\n\n[aria-checked=\"true\"] > .permisos-switch {\n    background: var(--senal);\n}\n\n[aria-checked=\"true\"] > .permisos-switch::after {\n    transform: translateX(0.95rem);\n}\n\n.permisos-switch-boton {\n    display: inline-flex;\n    padding: 0.35rem;\n    border: 0;\n    border-radius: 999px;\n    background: transparent;\n    cursor: pointer;\n}\n\n.permisos-switch-boton:focus-visible,\n.permisos-toma:focus-visible,\n.permisos-formulario .btn:focus-visible {\n    outline: 2px solid var(--ink);\n    outline-offset: 2px;\n}\n\n/* Toma: un interruptor con su nombre, para el alta y la ficha */\n\n.permisos-toma {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    width: 100%;\n    min-height: 2.75rem;\n    padding: 0.55rem 0.75rem;\n    border: 1px solid var(--line);\n    border-radius: 4px;\n    background: #fff;\n    color: var(--soft);\n    text-align: left;\n    cursor: pointer;\n    transition: border-color 0.16s ease, box-shadow 0.16s ease, color 0.16s ease;\n}\n\n.permisos-toma:hover {\n    border-color: var(--field);\n    color: var(--ink);\n}\n\n.permisos-toma[aria-checked=\"true\"] {\n    border-color: var(--ink);\n    box-shadow: inset 3px 0 0 var(--senal);\n    color: var(--ink);\n}\n\n.permisos-toma-texto {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.permisos-toma-nombre {\n    font-weight: 600;\n    font-size: 0.9rem;\n    line-height: 1.2;\n}\n\n.permisos-toma-ayuda {\n    margin-top: 0.15rem;\n    font-size: 0.78rem;\n    line-height: 1.3;\n    color: var(--soft);\n}\n\n.permisos-codigo {\n    font-family: var(--mono);\n    font-size: 0.95rem;\n    font-weight: 600;\n    letter-spacing: 0.01em;\n    color: var(--ink);\n}\n\n/* Listado */\n\n.permisos-roster {\n    margin-top: 0.4rem;\n}\n\n.permisos-roster-head {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 0.75rem 1.25rem;\n    margin-bottom: 0.6rem;\n}\n\n.permisos-cuenta {\n    margin: 0.2rem 0 0;\n    color: var(--soft);\n    font-size: 0.8rem;\n}\n\n.permisos-buscar {\n    position: relative;\n    width: min(100%, 20rem);\n}\n\n.permisos-buscar-icono {\n    position: absolute;\n    top: 50%;\n    left: 0.7rem;\n    transform: translateY(-50%);\n    color: var(--field);\n    font-size: 0.8rem;\n    pointer-events: none;\n}\n\n.permisos-buscar .form-control {\n    padding-left: 2rem;\n}\n\n.permisos-tabla-wrap {\n    overflow-x: auto;\n    border-top: 2px solid var(--ink);\n}\n\n.permisos-tabla {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.permisos-tabla thead th {\n    padding: 0.55rem 0.6rem;\n    border-bottom: 1px solid var(--line);\n    color: var(--soft);\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-align: left;\n    white-space: nowrap;\n}\n\n.permisos-tabla thead th.permisos-th-indicador {\n    width: 8.5rem;\n    text-align: center;\n}\n\n.permisos-tabla tbody tr {\n    border-bottom: 1px solid var(--line);\n    transition: background-color 0.12s ease;\n}\n\n.permisos-tabla tbody tr:hover {\n    background: #f8fafc;\n}\n\n.permisos-tabla tbody tr.es-ficha {\n    background: var(--sheet);\n    box-shadow: inset 3px 0 0 var(--senal);\n}\n\n.permisos-tabla tbody th,\n.permisos-tabla tbody td {\n    padding: 0.4rem 0.6rem;\n    vertical-align: middle;\n}\n\n.permisos-email {\n    font-weight: 600;\n    color: var(--ink);\n    word-break: break-all;\n}\n\n.permisos-email-dominio {\n    font-weight: 400;\n    color: var(--soft);\n}\n\n.permisos-td-indicador {\n    text-align: center;\n}\n\n.permisos-acciones {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.35rem;\n    white-space: nowrap;\n}\n\n.permisos-nadie {\n    padding: 1rem 0.6rem;\n    color: var(--soft);\n    font-size: 0.9rem;\n}\n\n/* Botones */\n\n.permisos-formulario .permisos-commit {\n    background: var(--ink);\n    border-color: var(--ink);\n    border-radius: 4px;\n    color: #fff;\n    font-weight: 600;\n}\n\n.permisos-formulario .permisos-commit:hover:not(:disabled) {\n    background: #121a2c;\n    border-color: #121a2c;\n    color: #fff;\n}\n\n.permisos-formulario .permisos-commit:disabled {\n    background: #c5cedb;\n    border-color: #c5cedb;\n    color: #fff;\n    opacity: 1;\n}\n\n.permisos-formulario .permisos-abrir {\n    padding: 0.25rem 0.7rem;\n    border: 1px solid #c5cedb;\n    border-radius: 4px;\n    background: transparent;\n    color: var(--ink);\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n.permisos-formulario .permisos-abrir:hover {\n    background: var(--ink);\n    border-color: var(--ink);\n    color: #fff;\n}\n\n.permisos-formulario .permisos-borrar {\n    width: 2rem;\n    height: 2rem;\n    padding: 0;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    background: transparent;\n    color: var(--peligro);\n    font-size: 0.85rem;\n}\n\n.permisos-formulario .permisos-borrar:hover {\n    background: var(--peligro);\n    border-color: var(--peligro);\n    color: #fff;\n}\n\n/* Ficha */\n\n.permisos-modal-eyebrow {\n    display: block;\n    color: var(--soft);\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.permisos-modal-email {\n    display: block;\n    margin-top: 0.2rem;\n    color: var(--ink);\n    font-size: 1.35rem;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n    word-break: break-all;\n}\n\n.permisos-bloque + .permisos-bloque {\n    margin-top: 1.5rem;\n    padding-top: 1.25rem;\n    border-top: 1px solid var(--line);\n}\n\n.permisos-bloque-cabeza {\n    margin-bottom: 0.75rem;\n}\n\n.permisos-bloque-nombre {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--ink);\n}\n\n.permisos-bloque-ayuda {\n    margin: 0.15rem 0 0;\n    color: var(--soft);\n    font-size: 0.85rem;\n}\n\n.permisos-dominios {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(8.5rem, 1fr));\n    gap: 0.6rem;\n}\n\n.permisos-origenes {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.permisos-origen {\n    display: grid;\n    grid-template-columns: minmax(5rem, 9rem) minmax(0, 1fr) 2.75rem minmax(0, 1fr);\n    align-items: center;\n    padding: 0.35rem 0;\n}\n\n.permisos-origen + .permisos-origen {\n    border-top: 1px dashed var(--line);\n}\n\n/* Conector: une Enviar y Listas cuando las listas arrastran el envío */\n\n.permisos-conector {\n    height: 2px;\n    background-image: linear-gradient(90deg, var(--line) 50%, transparent 50%);\n    background-size: 6px 2px;\n    transition: background 0.16s ease;\n}\n\n.con-envio .permisos-conector {\n    background: var(--line);\n}\n\n.con-listas .permisos-conector {\n    height: 3px;\n    background: var(--senal);\n}\n\n.arrastre-previsto .permisos-conector {\n    height: 3px;\n    background-image: linear-gradient(90deg, var(--senal) 50%, transparent 50%);\n    background-size: 8px 3px;\n}\n\n.permisos-toma.se-arrastra {\n    border-style: dashed;\n    border-color: var(--senal);\n    background: #fff6ee;\n    color: var(--ink);\n}\n\n.permisos-estado {\n    flex: 1 1 auto;\n    margin: 0;\n    color: var(--soft);\n    font-size: 0.85rem;\n}\n\n.permisos-estado.es-error {\n    color: var(--peligro);\n    font-weight: 600;\n}\n\n@media (max-width: 760px) {\n    .permisos-page {\n        padding-top: 0.85rem;\n    }\n\n    .permisos-sheet {\n        padding: 0.95rem 0.85rem 0.9rem;\n    }\n\n    .permisos-title {\n        font-size: 1.7rem;\n    }\n\n    .permisos-alta,\n    .permisos-alta-indicadores {\n        grid-template-columns: 1fr;\n    }\n\n    .permisos-alta-accion {\n        order: 3;\n    }\n\n    .permisos-alta-accion .btn {\n        width: 100%;\n    }\n\n    .permisos-roster-head {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .permisos-buscar {\n        width: 100%;\n    }\n\n    .permisos-tabla thead {\n        position: absolute;\n        width: 1px;\n        height: 1px;\n        margin: -1px;\n        overflow: hidden;\n        clip: rect(0, 0, 0, 0);\n        white-space: nowrap;\n    }\n\n    .permisos-tabla tbody tr {\n        display: grid;\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n        padding: 0.75rem 0.25rem;\n    }\n\n    .permisos-tabla tbody th,\n    .permisos-tabla tbody td {\n        display: block;\n        padding: 0.2rem 0.35rem;\n    }\n\n    .permisos-tabla tbody th.permisos-email,\n    .permisos-tabla tbody td.permisos-td-acciones,\n    .permisos-tabla tbody td.permisos-nadie {\n        grid-column: 1 / -1;\n    }\n\n    .permisos-td-indicador {\n        text-align: left;\n    }\n\n    .permisos-td-indicador::before {\n        content: attr(data-label);\n        display: block;\n        color: var(--soft);\n        font-size: 0.72rem;\n        font-weight: 600;\n    }\n\n    .permisos-switch-boton {\n        padding-left: 0;\n    }\n\n    .permisos-acciones {\n        justify-content: space-between;\n        margin-top: 0.35rem;\n    }\n\n    .permisos-origen {\n        grid-template-columns: 1fr 1fr;\n        gap: 0.45rem 0.6rem;\n        padding: 0.6rem 0;\n    }\n\n    .permisos-origen > .permisos-codigo {\n        grid-column: 1 / -1;\n    }\n\n    .permisos-conector {\n        display: none;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .permisos-alta-panel,\n    .permisos-alta-panel.abierta,\n    .permisos-alta-toggle,\n    .permisos-alta-toggle-icono,\n    .permisos-switch,\n    .permisos-switch::after,\n    .permisos-toma,\n    .permisos-conector,\n    .permisos-tabla tbody tr {\n        transition: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
